import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CTABanner = ({ 
  title, 
  subtitle,
  buttonText = "Contact Us",
  buttonLink = "/contact",
  variant = "default" // default, light
}) => {
  const bgClass = variant === "light" 
    ? "bg-[#F8FAFC] border border-slate-200" 
    : "bg-[#0F172A]";
  const textClass = variant === "light" ? "text-[#0F172A]" : "text-white";
  const subtitleClass = variant === "light" ? "text-[#0F172A]/60" : "text-white/70";

  return (
    <section 
      data-testid="cta-banner"
      className={`py-16 lg:py-20 ${bgClass}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 
          className={`text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${textClass}`}
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          {title}
        </h2>
        
        {subtitle && (
          <p className={`mt-4 text-lg ${subtitleClass} max-w-2xl mx-auto`}>
            {subtitle}
          </p>
        )}
        
        <Link to={buttonLink}>
          <Button 
            data-testid="cta-banner-button"
            className="mt-8 bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-6 text-base font-medium rounded-xl"
          >
            {buttonText}
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default CTABanner;
